import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3315 5.18355L17.3094 9.60829C18.2399 10.4355 18.7052 10.8491 18.8767 11.3374C19.0273 11.7663 19.0273 12.2337 18.8767 12.6626C18.7052 13.1509 18.2399 13.5645 17.3094 14.3917L12.3315 18.8165C11.9092 19.1918 11.6981 19.3795 11.5187 19.3862C11.3629 19.3921 11.2133 19.3249 11.1142 19.2046C11 19.0661 11 18.7835 11 18.2185V15.4286C8.57196 15.4286 6.00739 16.2084 4.13478 17.5928C3.15988 18.3135 2.67242 18.6739 2.48676 18.6596C2.30578 18.6458 2.19093 18.5751 2.09703 18.4198C2.0007 18.2604 2.08578 17.7625 2.25595 16.7667C3.36093 10.3006 7.8109 8.57143 11 8.57143V5.78148C11 5.21646 11 4.93396 11.1142 4.79545C11.2133 4.67513 11.3629 4.60794 11.5187 4.61378C11.6981 4.62049 11.9092 4.80818 12.3315 5.18355Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9889 3.98966C15.2708 3.68613 15.7453 3.66856 16.0488 3.95041L21.2651 8.79403C22.212 9.67333 22.75 10.9072 22.75 12.1994C22.75 13.5616 22.1524 14.8553 21.1151 15.7382L16.0246 20.0711C15.7092 20.3396 15.2359 20.3016 14.9674 19.9861C14.6989 19.6707 14.737 19.1974 15.0524 18.9289L20.1428 14.596C20.8453 13.998 21.25 13.122 21.25 12.1994C21.25 11.3243 20.8857 10.4887 20.2444 9.89322L15.0282 5.0496C14.7246 4.76775 14.7071 4.2932 14.9889 3.98966Z"
        fill={colorValue}
      />
    </svg>
  );
};
